import { useCookie } from "react-use";
import { AUTH_COOKIE_NAME, cookieOptions } from "../constants";
/**
 * Hook for persisting authentication state in a cookie
 */
export function useCookieAuthState() {
    const [cookie, setCookie, removeCookie] = useCookie(AUTH_COOKIE_NAME);
    const setAuthState = (newState, updatedAt = Date.now()) => {
        setCookie(JSON.stringify(Object.assign(Object.assign({}, newState), { timestamp: updatedAt })), cookieOptions);
    };
    const clearAuthState = () => {
        removeCookie();
    };
    const getAuthState = () => {
        try {
            const state = cookie
                ? JSON.parse(cookie)
                : undefined;
            return state;
        }
        catch (_a) {
            clearAuthState();
            return undefined;
        }
    };
    return {
        isAuthenticated: !!getAuthState(),
        state: getAuthState(),
        setAuthState,
        clearAuthState,
    };
}
//# sourceMappingURL=useCookieAuthState.js.map